import { render, staticRenderFns } from "./CoreDrawer.vue?vue&type=template&id=d555e90a&"
import script from "./CoreDrawer.vue?vue&type=script&lang=js&"
export * from "./CoreDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CoreDrawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports